import CategoriesTab from './CategoriesTab'
export default CategoriesTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/CategoriesTab/index.js